import { useNavigate } from "react-router-dom";

type PageKey = "home" | "work" | "method" | "about";

interface SwiperNavProps {
  currentPage: PageKey;
  onNavigate: (page: PageKey) => void;
}

const swiperItems: { key: PageKey; label: string }[] = [
  { key: "home", label: "HOME" },
  { key: "work", label: "WORK" },
  { key: "method", label: "METHOD" },
  { key: "about", label: "ABOUT" },
];

const routeItems = [
  { path: "/blog", label: "BLOG" },
  { path: "/research", label: "RESEARCH" },
];

const SwiperNav = ({ currentPage, onNavigate }: SwiperNavProps) => {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-foreground/[0.08]">
      <div className="flex items-center justify-between px-6 md:px-10 h-14">
        <div className="flex items-center gap-4 md:gap-8 overflow-x-auto">
          {swiperItems.map((item) => (
            <button
              key={item.key}
              onClick={() => onNavigate(item.key)}
              className={`text-[11px] tracking-[0.2em] font-sans uppercase transition-colors duration-300 bg-transparent border-none cursor-pointer whitespace-nowrap ${
                currentPage === item.key
                  ? "text-foreground"
                  : "text-foreground/40 hover:text-foreground/70"
              }`}
            >
              [{item.label}]
            </button>
          ))}
          {routeItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="text-[11px] tracking-[0.2em] font-sans uppercase transition-colors duration-300 bg-transparent border-none cursor-pointer whitespace-nowrap text-foreground/40 hover:text-foreground/70"
            >
              [{item.label}]
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default SwiperNav;
export type { PageKey };
